import clsx from 'clsx'

const Hero = ({ title, imageUrl, size = 'large', children }) => {
    const heightClass = clsx({
        'h-[40vh] sm:h-[60vh]': size === 'medium',
        'h-[60vh] sm:h-[80vh] md:h-[90vh]': size === 'large',
    })

    return (
        <div
            className={`relative w-full ${heightClass} bg-center bg-cover flex flex-col items-center justify-center text-center`}
            style={{ backgroundImage: `url(${imageUrl})` }}
        >
            {/* Dark overlay for readability */}
            <div className='absolute top-0 left-0 z-0 w-full h-full bg-black/50'></div>

            {/* Title */}
            <h1 className='z-10 max-w-screen-md px-4 text-2xl font-bold text-white sm:text-3xl md:text-5xl'>
                {title}
            </h1>

            {/* Optional children */}
            {children && <div className='z-10 w-full max-w-screen-sm px-4 mt-4'>{children}</div>}
        </div>
    )
}

export default Hero
